var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.538 43.8109L13.8919 33.1927C13.7852 33.1287 13.6924 33.0432 13.619 32.9414C13.5456 32.8396 13.4932 32.7236 13.465 32.6005C13.4365 32.4772 13.4328 32.3493 13.4539 32.2245C13.475 32.0997 13.5206 31.9805 13.5879 31.8741L31.234 3.76816C31.3219 3.64441 31.4372 3.54365 31.5704 3.47405C31.7037 3.40446 31.8511 3.36801 32.0007 3.36768C32.1503 3.36762 32.2978 3.40383 32.4311 3.47334C32.5643 3.54284 32.6796 3.64365 32.7674 3.76751L50.4135 31.8748C50.4807 31.981 50.5262 32.1 50.5473 32.2246C50.5684 32.3492 50.5646 32.4769 50.5362 32.6C50.5078 32.7231 50.4554 32.8391 50.3821 32.941C50.3087 33.0428 50.216 33.1285 50.1095 33.1927L32.4634 43.8109C32.3233 43.8955 32.1635 43.9402 32.0007 43.9402C31.8379 43.9402 31.6781 43.8955 31.538 43.8109Z",
    fill: "#61ECFF",
    stroke: "url(#paint0_linear_442_681)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3355 38.3742C50.1981 38.2112 50.0098 38.1018 49.8026 38.0644C49.5953 38.0271 49.3818 38.0642 49.1982 38.1693L32.0546 48.0166H31.9451L14.8014 38.1811C14.6176 38.0757 14.4038 38.0385 14.1962 38.0759C13.9886 38.1133 13.8001 38.223 13.6625 38.3863C13.525 38.5497 13.447 38.7566 13.4417 38.9721C13.4364 39.1875 13.5041 39.3982 13.6334 39.5684L31.2763 62.5702L31.307 62.6016L31.3922 62.6945L31.4472 62.7442L31.5502 62.813L31.611 62.8437L31.7454 62.8934H31.7998C31.9298 62.9248 32.0648 62.9248 32.1954 62.8934H32.2498L32.3842 62.8437L32.4443 62.813L32.548 62.7442L32.6024 62.6945L32.6882 62.6016L32.7182 62.5702L50.3605 39.5684C50.4939 39.398 50.5645 39.185 50.5601 38.9668C50.5556 38.7485 50.4757 38.5388 50.3355 38.3742Z",
    fill: "#61ECFF",
    stroke: "url(#paint1_linear_442_681)",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3193 10.8931V37.723",
    stroke: "#035D68",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_442_681",
    x1: 13.4407,
    y1: 3.36768,
    x2: 13.4407,
    y2: 43.9398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00191D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966734,
    stopColor: "#035D68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_442_681",
    x1: 13.4395,
    y1: 38.0502,
    x2: 13.4395,
    y2: 62.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#035D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00191D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumCoin);
export default __webpack_public_path__ + "static/media/EthereumCoin.4891697b3126ee5e633683ef7c7ce235.svg";
export { ForwardRef as ReactComponent };